import { ContentTypeFilterClause, ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { FlowOutputStepRunContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { FlowOutputStepRuns } from '../../resources/FlowOutputStepRuns';

export const FlowOutputStepRunDefinition: ExplorableItemDefinition = {
  itemType: 'flowOutputStepRun',
  pluralName: Messages.flowRuns,
  emptyStateMessage: Messages.flowRunsEmptyMessage,
  contentFilterKeys: FlowOutputStepRunContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: null,
  listViewIconUrl: '', // we don't display an icon for flow output step runs
  filterClause: ServerFilterClauses.ContentType(['flowOutputStepRun']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return FlowOutputStepRuns.all().withExtraParams(FlowOutputStepRunContentType.extraQueryParams);
  },
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for flowOutputStepRun');
  },
  supportedDisplayModes: ['list']
};
